const ROUND = 'stroke="currentColor" stroke-linecap="round"';

export const SUPERFAN_MARK =
  `<path d="M10.2 20.5 6 6.2M13.8 20.5 18 6.2" fill="none" ${ROUND} stroke-width="3"/>` +
  `<path d="M5.4 1.8v1.6M1.6 4.6l1.5.7M9.2 4.6l-1.5.7M18.6 1.8v1.6M22.4 4.6l-1.5.7M14.8 4.6l1.5.7" fill="none" ${ROUND} stroke-width="1.4"/>`;

export const RAPPEL_ICON = [
  [12, 7],
  [6, 16.5],
  [18, 16.5],
]
  .map(
    ([x = 0, y = 0]) =>
      `<path d="M${String(x - 1.8)} ${String(y + 1.8)}L${String(x + 1.8)} ${String(y - 1.8)}" fill="none" ${ROUND} stroke-width="2.6"/>` +
      `<circle cx="${String(x)}" cy="${String(y)}" r="4.6" fill="none" stroke="currentColor" stroke-width="1.4"/>`,
  )
  .join('');
